import React, { useMemo } from 'react';
import PreviewImage from '../PreviewImage';
import FourPoseGrid from './four-pose-grid';
import ThreePoseGrid from './three-pose-grid';
import TwoPoseGrid from './two-pose-grid';
import OnePoseGrid from './one-pose-grid';
import cn from 'classnames';
import styles from './pose-img.module.sass';

const PoseImg = ({ favorites, background, numPoses }) => {
  const minNum = useMemo(() => Math.min(favorites.length, numPoses), [favorites.length, numPoses]);
  const Component = useMemo(() => {
    if (minNum === 4) return FourPoseGrid;
    if (minNum === 3) return ThreePoseGrid;
    if (minNum === 2) return TwoPoseGrid;

    return OnePoseGrid;
  }, [minNum]);

  return (
    <div style={{ width: '80%', margin: '0 auto', position: 'relative' }}>
      <Component
        items={favorites.slice(0, minNum).map((item, i) => (
          <div
            className={cn({
              [styles.pose4]: i === 3 && minNum === 4,
              [styles.pose2]: i === 1 && minNum === 4,
              [styles.width50]: minNum > 2,
            })}
          >
            <PreviewImage
              isPreviewHidden={false}
              key={item.id}
              foregroundUrl={item.watermarkUrl}
              backgroundUrl={background.imageUrl}
              style={{ border: '2px solid #fff' }}
            />
          </div>
        ))}
      />
    </div>
  )
}

export default PoseImg
